// Angular Files
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    NavigationEnd,
    NavigationStart,
    Router,
    RouterStateSnapshot
} from '@angular/router';

// Component Files
import { TellerOnlineRumService } from './rum.service';

export type RumNavSource = 'landing' | 'history' | 'link';

/**
 * The route template of a router state (`/search/:id`), never the URL: raw URLs would give every
 * id and query string its own page. Unmatched routes are `/(unmatched)`.
 */
export function routeTemplate(snapshot: RouterStateSnapshot): string {
    const segments: string[] = [];
    let route: ActivatedRouteSnapshot | null = snapshot.root;
    while (route) {
        const path = route.routeConfig?.path;
        if (path === '**') {
            segments.push('(unmatched)');
        } else if (path) {
            segments.push(path);
        }
        route = route.firstChild;
    }

    return `/${segments.join('/')}`;
}

/** Records one RUM page view per completed navigation. */
@Injectable({ providedIn: 'root' })
export class TellerOnlineRumNavigationService {
    private _started = false;

    private _navigations = 0;

    private _source: RumNavSource = 'landing';

    constructor(
        private router: Router,
        private rumService: TellerOnlineRumService
    ) { }

    public start(): void {
        if (this._started || !this.rumService.enabled) return;

        this._started = true;
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                const inApp: RumNavSource = event.navigationTrigger === 'popstate'
                    ? 'history'
                    : 'link';
                this._source = this._navigations === 0 ? 'landing' : inApp;
            } else if (event instanceof NavigationEnd) {
                this._navigations++;
                this.rumService.recordPageView(
                    routeTemplate(this.router.routerState.snapshot),
                    { navSource: this._source }
                );
            }
        });
    }
}
